import { Component, Output, Input, EventEmitter, ViewChildren } from '@angular/core';
import { ApiService } from '../../shared/api.service';
import { ImagesService } from '../../shared/images.service';

@Component({
    selector: 'image-details-component',
    templateUrl: 'image-details.component.html'
})
export class ImageDetailsComponent {
    canvas;
    canvasContext;
    captionCharacterCount = 45;
    brightness = 0;
    contrast = 0;
    options = false;
    optionsError = '';
    saving = false;
    sizes = [
        {
            value: 'mobile',
            label: 'Mobile',
            fixed: false,
            width: 480,
            height: 720
        },
        {
            value: 'medium',
            label: 'Mobile (Legacy)',
            fixed: false,
            width: 480,
            height: 0
        },
        {
            value: 'large',
            label: 'Tablet',
            fixed: false,
            width: 1024,
            height: 0
        },
        {
            value: 'quiz',
            label: 'Quiz',
            fixed: true,
            width: 756,
            height: 331
        },
        {
            value: 'ad',
            label: 'Ad Ops',
            fixed: true,
            width: 1200,
            height: 630
        },
        {
            value: 'feed_square',
            label: 'Feed Square',
            fixed: true,
            width: 300,
            height: 300
        },
        {
            value: 'thumbnail',
            label: 'Thumbnail',
            fixed: true,
            width: 150,
            height: 150
        }
    ];
    private _canEdit = false;
    private _dialog = false;
    private _image = {
        alt: '',
        caption: '',
        id: 0,
        title: '',
        url: '',
        sizes: [],
        width: 0,
        height: 0,
        original: ''
    };
    private _post = 0;
    private _mobileOnly = false;

    @Input('canEdit')
    set canEdit(canEdit) {
        this._canEdit = canEdit;
    }
    get canEdit() {
        return this._canEdit;
    }
    @Input('dialog')
    set dialog(dialog) {
        this._dialog = dialog;
    }
    get dialog() {
        return this._dialog;
    }
    @Input('image') 
    set image(image) {
        this._image = image;
    }
    get image() {
        return this._image;
    }
    @Input('post') 
    set post(post) {
        this._post = post;
    }
    get post() {
        return this._post;
    }
    @Input('mobileOnly') 
    set mobileOnly(mobileOnly) {
        this._mobileOnly = mobileOnly;
    }
    get mobileOnly() {
        return this._mobileOnly;
    }

    @Output() imageChange = new EventEmitter();

    @ViewChildren('cropper') croppers;
    
    constructor(
        private api: ApiService, 
        private imagesService: ImagesService
    ) {}
    ngAfterViewInit() {
        if( this.image.title !== '' && this.image.alt == '' ) {
            this.image.alt = this.image.title;
        }
        const crop = this.image['crop'] || {};
        if( crop.b ) {
            this.brightness = crop.b / 100;
        }
        if( crop.c ) {
            this.contrast = crop.c / 100;
        }
    }
    cleanText(text) {
        return text.replace(/(<([^>]+)>)/ig,'');
    }
    getCharacterCount() {
        return this.cleanText(this.image.caption).length;
    }
    titleChange() {
        this.image.title = this.cleanText(this.image.title);
        this.save();
    }
    altChange() {
        this.image.alt = this.cleanText(this.image.alt);
        this.save();
    }
    save() {
        const data = {
            action: 'update',
            image: this.image
        }
        this.api.doAction('post', 'image', data).subscribe();
        this.imagesService.imagesChange.emit(this.imagesService.images);
    }
    updateAllCroppers() {
        const croppers = this.croppers;
        croppers.forEach((cropper, i) => {
            cropper.filterImage({
                brightness: this.brightness,
                contrast: this.contrast
            });            
        });
        if( this.mobileOnly ) {
            const mobileSize = this.image.sizes['mobile'] ? 'mobile' : 'medium';
            let sizes = Object.keys(this.image.sizes).filter(item => item !== mobileSize);
            const newCrop = {
                b: Math.round(this.brightness * 100),
                c: Math.round(this.contrast * 100)
            }
            const crop = this.image['crop'];
            if( !crop ) {
                this.image['crop'] = newCrop;
            } else {
                this.image['crop'] = Object.assign(crop, newCrop);
            }
            for(var i = 0; i < sizes.length; i++) {
                const size = sizes[i];
                let image = this.image.sizes[size];
                if( image.crop ) {
                    this.image.sizes[size].crop = Object.assign(image.crop, newCrop);
                } else {
                    this.image.sizes[size].crop = newCrop;
                }
                this.image.sizes[size].urlWithParams = this.image.url + this.image['buildHttpParams'](image.crop);
                this.imagesService.refreshImage(this.image.id, image.urlWithParams, size);
            }
        }
    }
    resetOptions() {
        this.brightness = 0;
        this.contrast = 0;
        this.updateAllCroppers();
    }
    optionChange(e, filter) {
        this[filter] = e.value;
        this.updateAllCroppers();
    }
    userCanView(size) {
        const user = this.api.getProp('user');
        if( user.role == 'writer' && (size != 'medium' && size !== 'mobile' && size != 'quiz' && size != 'thumbnail') ) {
            return false;
        }
        return true;
    }
    getMobileSize(size) {
        return this.sizes.filter(item => item.value == size ).shift();
    }
    allowLandscapeChange(e) {
        if( e.checked ) {
            delete this.image.sizes['mobile'];
        }
        if( this.image.sizes['medium'].width != 480 ) {
            const width = 480;
            const height = this.image.height * (width / this.image.width);
            this.image.sizes['medium'].crop = {
                width: width,
                height: Math.round(height)
            };
            this.image.sizes['medium'].urlWithParams = this.image.url + this.image['buildHttpParams'](this.image.sizes['medium'].crop);
        }
        this.imagesService.imagesChange.emit(this.imagesService.images);
    }
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/slideshow/images/image-details.component.ts